import React from 'react';
import { WxbIcon } from '../Icon/Icon';
import type { WxbIconName } from '../Icon/icons';
import type { WxbStatusTone } from '../StatusBadge/StatusBadge';
import './ActivityFeed.css';

export interface WxbActivityFeedItem {
  key: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  timestamp?: React.ReactNode;
  actor?: React.ReactNode;
  icon?: WxbIconName | React.ReactNode;
  tone?: WxbStatusTone;
  meta?: React.ReactNode;
  actions?: React.ReactNode;
}

export interface WxbActivityFeedProps extends React.HTMLAttributes<HTMLDivElement> {
  items: WxbActivityFeedItem[];
  density?: 'comfortable' | 'compact';
  emptyText?: React.ReactNode;
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

const renderIcon = (icon: WxbActivityFeedItem['icon']) => {
  if (!icon) return <WxbIcon name="batch-record" size={16} />;
  if (typeof icon === 'string') return <WxbIcon name={icon} size={16} />;
  return icon;
};

export const WxbActivityFeed: React.FC<WxbActivityFeedProps> = ({
  items,
  density = 'comfortable',
  emptyText = '暂无活动',
  className = '',
  ...props
}) => (
  <div className={joinClasses('wxb-activity-feed', `wxb-activity-feed-${density}`, className)} {...props}>
    {items.length === 0 ? (
      <div className="wxb-activity-feed-empty">{emptyText}</div>
    ) : items.map((item) => (
      <div className="wxb-activity-item" key={item.key}>
        <span className={joinClasses('wxb-activity-marker', `wxb-activity-marker-${item.tone ?? 'neutral'}`)}>
          {renderIcon(item.icon)}
        </span>
        <span className="wxb-activity-body">
          <span className="wxb-activity-head">
            <span className="wxb-activity-title">{item.title}</span>
            {item.timestamp && <span className="wxb-activity-time">{item.timestamp}</span>}
          </span>
          {item.description && <span className="wxb-activity-description">{item.description}</span>}
          {(item.actor || item.meta || item.actions) && (
            <span className="wxb-activity-footer">
              {item.actor && <span className="wxb-activity-actor">{item.actor}</span>}
              {item.meta && <span className="wxb-activity-meta">{item.meta}</span>}
              {item.actions && <span className="wxb-activity-actions">{item.actions}</span>}
            </span>
          )}
        </span>
      </div>
    ))}
  </div>
);

